import $ from "jquery";
import initPage from "./page/index";
import initApplyModal from "./initApplyModal";
import initMenu from "./initMenu";
import { getFooterInfo } from "./page/footer"
$(document).ready(function () {
  initPage();
  initMenu();
  initApplyModal();
  getFooterInfo()
});
